const archiveType = {
  EMAIL: 'EMAIL',
  VAULT: 'VAULT_O365_ARCHIVE'
};
const userStatuses = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  ARCHIVED: 'ARCHIVED'
};
const projectStatus = {
  WAITING: 'WAITING_FOR_APPROVAL',
  ARCHIVED: 'ARCHIVED'
};
const mailSyncPageType = {
  systemAdmin: 'SYSTEM_ADMIN',
  org: 'ORG'
};
const alertType = {
  user: 'USER',
  system: 'USER_DEFAULT'
};
const onboardingStatus = {
  started: 'STARTED',
  first: 'USER_GROUP',
  // payment_method: 'PAYMENT_METHOD',
  second: 'SSO',
  third: 'CONNECTORS',
  fourth: 'THANKS',
  done: 'ONBOARDED'
};
const varStatus = {
  notVar: 'NOT_A_VAR',
  canAddVars: 'VAR_WHO_CAN_ADD_VARS',
  cannotAddVars: 'VAR_WHO_CANNOT_ADD_VARS'
};
const numbers = {
  two: 2
};
// Office 365 connectors
const O365_CONNECTORS = {
  usersAndGroups: {
    connectorId: 'o365_group',
    connectorName: 'Users & Groups'
  },
  email: {
    connectorId: 'o365_email',
    connectorName: 'Email'
  },
  sharepoint: {
    connectorId: 'o365_sharepoint',
    connectorName: 'SharePoint'
  },
  onedrive: {
    connectorId: 'o365_onedrive',
    connectorName: 'OneDrive'
  },
  teams: {
    connectorId: 'o365_teams',
    connectorName: 'Teams'
  },
  dropbox: {
    connectorId: 'dropbox',
    connectorName: 'Dropbox'
  },
  export_to_dropbox: {
    connectorId: 'export_to_dropbox',
    connectorName: 'Export to Dropbox'
  }
};
const connectorsWritePermissionMap = {
  o365_onedrive: 'ediscovery_project_export',
  dropbox: 'export_to_dropbox'
};
const defaultExportPointMap = {
  o365_sharepoint: 'o365_onedrive',
  o365_onedrive: 'o365_onedrive',
  o365_teams: 'o365_onedrive',
  dropbox: 'dropbox'
};
// Connectors created dynamically from backend while creating subscription
const dynamicConnectors = [
  O365_CONNECTORS.sharepoint.connectorId,
  O365_CONNECTORS.onedrive.connectorId,
  O365_CONNECTORS.teams.connectorId,
  O365_CONNECTORS.email.connectorId
];
const exportableConnectors = ['ediscovery_project_export', 'export_to_dropbox'];
export default {
  archiveType,
  userStatuses,
  projectStatus,
  mailSyncPageType,
  alertType,
  onboardingStatus,
  varStatus,
  numbers,
  dynamicConnectors,
  O365_CONNECTORS,
  exportableConnectors,
  connectorsWritePermissionMap,
  defaultExportPointMap
};
